import React, {useCallback, useRef, useState} from 'react';
import './index.css';
import { toPng } from 'html-to-image';
import {
    AVAILABLE_FACES,
    AVAILABLE_BODIES,
    AVAILABLE_HAIRSTYLES,
    AVAILABLE_HAIRSTYLES_BACK,
    AVAILABLE_FACES_BACK,
    AVAILABLE_BODIES_LEFT,
    AVAILABLE_FACES_LEFT,
    AVAILABLE_HAIRSTYLES_LEFT,
    AVAILABLE_HAIRSTYLES_RIGHT, AVAILABLE_FACES_RIGHT, AVAILABLE_BODIES_RIGHT, AVAILABLE_BODIES_BACK
} from "./assets";
import axios from "axios";
export function StartButton({hairIndex, faceIndex, bodyIndex, customClothesColor, customSkinColor, customHairColor, userName}) {


    const uploadPicture = async (file, username) => {
        const formData = new FormData()
        formData.append("file", file)
        formData.append("upload_preset", "ml_default")
        formData.append("public_id", username)
        formData.append("api_key", "494322894714732")
        return await axios.post(
            `https://api.cloudinary.com/v1_1/${username}/image/upload`,
            formData
        ).then((response) => {
            const httpsUrl = response.data["secure_url"]
            const httpUrl = response.data["url"]
            window.location.href = `https://playinnoarcade.inbake2.com?userName=${username}&imageUrl=${httpUrl}`;
        })
    }

    const ref = useRef(undefined);
    const [inputValue, setInputValue] = useState("");
    const filter = (node) => {
        const exclusionClasses = ['startButton'];
        return !exclusionClasses.some((classname) => node.classList?.contains(classname));
    }

    function getCustomColor(index) {
        if (index === 0) {
            return customHairColor
        } else if (index === 1) {
            return customSkinColor
        } else if (index === 2) {
            return customClothesColor
        }
    }

    function buildComponentSelector(indexArray, availableComponents, index, imageStyle = {}) {
        const MyComponent = availableComponents[indexArray]
        return <div style={{height: "20px", display: "flex"}}>
            <MyComponent style={{...imageStyle, "--custom-color": getCustomColor(index), "--custom-skin-color": getCustomColor(1)}}/>
            </div>;
    }

    const onButtonClick = useCallback(() => {
        if (ref.current === null) {
            return
        }

        toPng(ref.current, { cacheBust: true, pixelRatio: 5, filter: filter})
            .then(async (base64Image) => {
                //const link = document.createElement('a')
                //link.download = 'my-image-name.png'
                //link.href = base64Image
                await uploadPicture(base64Image, userName)
                //link.click()
            })
            .catch((err) => {
                console.log(err)
            })
    }, [ref]);


    return <div style={{paddingTop: "95px", width: "500px", height: "80px", display: "flex"}}>
        <button onClick={onButtonClick} style={{
            className: "startButton",
            backgroundColor: "#F8D404",
            opacity: "90%",
            lineHeight: "80px",
            borderRadius: "20px",
            width: "100%",
            height: "100%",
            fontFamily: "PlanetKosmos",
            fontSize: "30px",
            marginRight: "30px",
            alignContent: "center",
            textAlign: "center",
            letterSpacing: "1px",
            color: "#171717",
            cursor: "pointer",
            zIndex: 5
        }} name="myInput"> Join Game
        </button>
        <div style={{display: "flex"}} ref={ref}>
            <div style={{width: "30px", marginLeft: "5px", height: "60px", marginTop: "5px"}}>
                {buildComponentSelector(hairIndex, AVAILABLE_HAIRSTYLES, 0, {
                    height: hairIndex >= 2 ? "36px" : "30px",
                    marginBottom: hairIndex >= 2 ? "-30px" : "-20px",
                    marginLeft: "1px",
                    alignSelf: "center",
                    zIndex: 3
                })}
                {buildComponentSelector(faceIndex, AVAILABLE_FACES, 1, {
                    alignSelf: "center",
                    marginTop: "-10px",
                    zIndex: 2
                })}
                {buildComponentSelector(bodyIndex, AVAILABLE_BODIES, 2, {alignSelf: "center", marginTop: "-12px", width: "30px"})}
            </div>
            <div style={{width: "30px", marginLeft: "5px", height: "60px", marginTop: "5px"}}>
                {buildComponentSelector(hairIndex, AVAILABLE_HAIRSTYLES_BACK, 0, {
                    height: hairIndex >= 2 ? "36px" : "30px",
                    marginBottom: hairIndex >= 2 ? "-30px" : "-20px",
                    marginLeft: "1px",
                    alignSelf: "center",
                    zIndex: 3
                })}
                {buildComponentSelector(faceIndex, AVAILABLE_FACES_BACK, 1, {
                    alignSelf: "center",
                    marginTop: "-10px",
                    zIndex: 2
                })}
                {buildComponentSelector(bodyIndex, AVAILABLE_BODIES_BACK, 2, {alignSelf: "center", marginTop: "-12px", width: "30px"})}
            </div>
            <div style={{width: "30px", marginLeft: "5px", height: "60px", marginTop: "5px"}}>
                {buildComponentSelector(hairIndex, AVAILABLE_HAIRSTYLES_LEFT, 0, {
                    height: hairIndex >= 2 ? "36px" : "30px",
                    marginBottom: hairIndex >= 2 ? "-30px" : "-20px",
                    marginLeft: "1px",
                    alignSelf: "center",
                    zIndex: 3
                })}
                {buildComponentSelector(faceIndex, AVAILABLE_FACES_LEFT, 1, {
                    alignSelf: "center",
                    marginTop: "-10px",
                    zIndex: 2
                })}
                {buildComponentSelector(bodyIndex, AVAILABLE_BODIES_LEFT, 2, {alignSelf: "center", marginTop: "-12px", width: "30px"})}
            </div>
            <div style={{width: "30px", marginLeft: "5px", height: "60px", marginTop: "5px"}}>
                {buildComponentSelector(hairIndex, AVAILABLE_HAIRSTYLES_RIGHT, 0, {
                    height: hairIndex >= 2 ? "36px" : "30px",
                    marginBottom: hairIndex >= 2 ? "-30px" : "-20px",
                    alignSelf: "center",
                    zIndex: 3
                })}
                {buildComponentSelector(faceIndex, AVAILABLE_FACES_RIGHT, 1, {
                    alignSelf: "center",
                    marginTop: "-10px",
                    zIndex: 2
                })}
                {buildComponentSelector(bodyIndex, AVAILABLE_BODIES_RIGHT, 2, {alignSelf: "center", marginTop: "-12px", width: "30px"})}
            </div>
        </div>
    </div>;

}
